import Init from '../../../extendable/Init';
import PageHeader from '../../../components/PageHeader/PageHeader';
import Join from '../../../components/Join/Join';

import './About.scss';

const About = () => {
};

Init(About);
